import { render } from "./position_career.vue?vue&type=template&id=b79324c2&ts=true"
import script from "./position_career.vue?vue&type=script&lang=ts"
export * from "./position_career.vue?vue&type=script&lang=ts"

import "./position_career.vue?vue&type=style&index=0&id=b79324c2&lang=scss"

import exportComponent from "/home/quangphuc/s-tech/admin-nhaongay/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__